module.exports = __webpack_public_path__ + "img/everTrust-logo-en.5a80dcdb.png";